@if ($user(); as user) {
  <wma-drawer-container class="flex-1" #drawer>
    <wma-drawer-sidenav>
      <div class="bg-primary-800 hidden h-full lg:flex lg:flex-col">
        <lgs-navigation [links]="links" class="hidden flex-1 overflow-y-auto lg:block" />
        <div
          class="border-primary-700 flex h-14 w-full shrink-0 items-center justify-center border-t"
        >
          <wma-profile-dropdown [user]="user" [showDocsLink]="true" (logout)="logout()" />
        </div>
      </div>
      <div class="lg:hidden">
        @if (drawer.open) {
          <div class="fixed inset-0 z-40 flex">
            <div
              animate.enter="animate-fade-in"
              animate.leave="animate-fade-out"
              class="absolute inset-0"
              (click)="drawer.closeSidebar()"
            >
              <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
            </div>
            <lgs-navigation
              animate.enter="animate-slide-in-left"
              animate.leave="animate-slide-out-left"
              [links]="links"
              (menuItemClick)="drawer.closeSidebar()"
              class="bg-primary-800 relative h-full w-full max-w-xs overflow-y-auto"
            />
          </div>
        }
      </div>
    </wma-drawer-sidenav>
    <wma-drawer-content cdkScrollable>
      <nav class="bg-primary-800 sticky top-0 z-50 lg:hidden print:hidden">
        <div class="px-4 sm:px-6 lg:px-8">
          <div class="flex h-14 items-center justify-between">
            <div class="lg:hidden">
              <button
                type="button"
                (click)="drawer.openSidebar()"
                class="bg-primary-800 text-primary-100 hover:bg-primary-600/75 focus:ring-offset-primary-800 me-3 inline-flex size-10 items-center justify-center rounded-md p-2 hover:text-white focus:ring-2 focus:ring-white focus:ring-offset-2 focus:outline-hidden"
                aria-label="Open sidebar"
              >
                <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
            @if (user) {
              <div class="ms-4 flex w-0 flex-1 items-center justify-end md:ms-6">
                <wma-profile-dropdown [user]="user" [showDocsLink]="true" (logout)="logout()" />
              </div>
            }
          </div>
        </div>
      </nav>
      <router-outlet />
    </wma-drawer-content>
  </wma-drawer-container>
}
